import { AcquiringChannel } from './application/acquiring-channel';
import { CardFee } from './application/card-fee';
import { DeliveryOptions } from './application/delivery-options';
import { PaymentMethodAPI, PaymentMethodCode } from './salesforce';

export type Catalogue = {
  products: CatalogueItem[];
  paymentMethods?: PaymentMethodAPI[];
  cardFees: {
    fees?: CardFee[];
    pricingTier?: string;
    status: DataStatus;
  };
  maxProductsPerOrder: number;
  statusAll: DataStatus;
  statusProducts: DataStatus;
  totals: {
    status: DataStatus;
    monthly?: number;
    onceOff?: number;
  };
};

export type Device = {
  // below values from API response
  title: string;
  featureTextList?: string[];
  imageBase64?: string;
  imageURL?: string;
  id: string;
  acquiringChannel: AcquiringChannel;
  secondaryAcquiringChannel?: AcquiringChannel;
  isProductCategory: boolean;
  productCategoryName: string;
  isCardPresent: boolean;
  allowedPaymentMethods: PaymentMethodCode[];
  isRental?: boolean;
  tagline: string;
  extraBenefits: string[];

  // below values derived from API response
  featureImageURLList?: string[];
  minQuantity?: number;
  maxQuantity?: number;

  // below values set by frontend
  quantity: number;
  quantityOld: number;
  deliveryOption?: DeliveryOptions;
  deliveryOptions: DeliveryOptions[];
  serialNumbers?: string[];
  friendlyTerminalName?: string[];
  isDeliverable?: boolean;
  isVirtual?: boolean;
  isTenderType: boolean;
  paymentMethodCode?: PaymentMethodCode;
};

export type CatalogueItem = {
  index: number;
  device: Device;
  card: {
    status: DataStatus;
    fees?: Fee[];
  };
  price: {
    status: DataStatus;
    /* in cents, VAT exclusive */
    price?: number;
    priceType?: PriceType;
    rentalPrice?: number; // in cents, VAT exclusive
  };
};

export enum DataStatus {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  LOADED = 'LOADED',
}

export enum PriceType {
  ONCE_OFF = 'ONCE_OFF',
  MONTHLY = 'MONTHLY',
  PAY_IN_STORE = 'PAY_IN_STORE',
  FREE = 'FREE',
}

export type Fee = {
  name: string;
  percentage: number;
};
